import { Alert, AlertTitle } from '@mui/material';
import { type ReactElement } from 'react';

import { locationArt, type ThemaFromThemaRouter } from '../../../../../dtos';
import { isPcCenterThema } from '../../../../../utils';
import { type CalendarEvent, CalendarSeminarraumResource } from '../../../ResourceCalendar';
import { isSeminarraumEvent } from '../../../ResourceCalendar/helperClasses';

export type WarningKeineUebernachtungsmoeglichkeitProps = {
  readonly thema: Pick<ThemaFromThemaRouter, 'planungsinformation'>;
  readonly pendingEvents: readonly CalendarEvent[];
  readonly seminarraumResources: readonly CalendarSeminarraumResource[];
};

export const WarningKeineUebernachtungsmoeglichkeit = ({
  thema,
  pendingEvents,
  seminarraumResources,
}: WarningKeineUebernachtungsmoeglichkeitProps): ReactElement | null => {
  const someRaumIsVeranstaltungslocationOrPcCenter = pendingEvents.some((event) =>
    isVeranstaltungslocationOrPcCenter(event, seminarraumResources),
  );

  if (isPcCenterThema(thema.planungsinformation) || someRaumIsVeranstaltungslocationOrPcCenter) {
    return (
      <Alert severity="info">
        <AlertTitle>Location ohne Übernachtungsmöglichkeit</AlertTitle>
        Die Veranstaltung findet in einer Location ohne Übernachtungsmöglichkeit statt. Plane die Veranstaltung in eine
        parallele Seminarrunde.
      </Alert>
    );
  }

  return null;
};

function isVeranstaltungslocationOrPcCenter(
  event: CalendarEvent,
  resources: readonly CalendarSeminarraumResource[],
): boolean {
  if (!isSeminarraumEvent(event)) {
    return false;
  }

  const resource = resources.find((r) => r.id === event.resource);
  if (!resource) {
    return false;
  }

  return (
    resource.location.art === locationArt.VERANSTALTUNGSLOCATION || //
    resource.location.art === locationArt.PC_CENTER
  );
}
